import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EventService } from '@ispm-client/modules/events/services/event.service';
import { get } from 'lodash';
import { OrderSFTPService } from '../../services/order.sftp.service';
import { OrderContentBaseComponent } from '../common/order-content-base.component';

@Component({
  selector: 'ispm-lab-order-content',
  templateUrl: './lab-order-content.component.html',
  styleUrls: ['./lab-order-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabOrderContentComponent extends OrderContentBaseComponent implements OnInit {
  private orderSFTPService: any;
  private changeStatusDetector: any;
  public contactDetails: null;
  public redrawDetails: String;
  @Output() onFormPartialSave: EventEmitter<any> = new EventEmitter();

  constructor(changeDetector: ChangeDetectorRef,
              _orderSFTPService: OrderSFTPService,
              _eventService: EventService) {
    super(changeDetector, _orderSFTPService, _eventService);
    this.orderSFTPService = _orderSFTPService;
    this.changeStatusDetector = changeDetector
  }


  /**
   * Angular lifecycle hooks
   * implements OnInit's `ngOnInit` method
   */
  public ngOnInit() {
    super.ngOnInit();
    this.contactDetails = get(this.config, 'contentPanel.contactDetails', null);
  }

  /**
   *ngOnChanges method
   */
  public ngOnChanges(changes: any) {
    this.redrawDetails = "";
    if (typeof changes.selectedOrderDetails?.currentValue !== 'undefined' && changes.selectedOrderDetails?.currentValue?.length) {
      const selectedDiagnostic = changes.selectedOrderDetails?.currentValue[0]?.id;
      this.orderSFTPService.allProgressionStatus(selectedDiagnostic).subscribe(progression => {
        let redrawStatus: any = progression.data.additionalProperties.expectedResults.filter(status => status.testStatus.includes('REDRAW'));
        let completedStatus: any = progression.data.additionalProperties.expectedResults.filter(status => status.testStatus.includes('COMPLETED')).map(obj => obj.testName);
        redrawStatus = redrawStatus.filter( item => completedStatus.indexOf( item.testName ) == -1  );
        if(redrawStatus?.length > 0 && progression.data.additionalProperties.overallResultStatus !== 'COMPLETED') {
          this.redrawDetails = this.getRedrawStatus(redrawStatus);
          this.changeStatusDetector.markForCheck();
        }
      });
    }
  }

  /**
   * @method getRedrawStatus
   */
  private getRedrawStatus(redrawStatus) {
    return redrawStatus.length > 1 ? `${redrawStatus[1].testName} and ${redrawStatus[0].testName}` : `${redrawStatus[0].testName}`
  }

  /**
   * @method savePartialOrderContent
   */
  savePartialOrderContent() {
    if (this._orderFormData?.form) {
      if(this._orderFormData?.form?.orders?.selectedOrderDetails[0] != undefined) {
        this._orderFormData.form.orders.selectedOrderDetails[0].orderStatus = "DRAFT";
      }
      this.onFormPartialSave.emit(this._orderFormData?.form);
      this.canEnablePartialSave = false;
    }
  }

  canUserWrite() {
    let derivedStatus = this.selectedOrderDetailsArray.length > 0 ? this.selectedOrderDetailsArray[0]?.derivedStatus.code : null
    return derivedStatus === 'IN_PROCESS' ? false : derivedStatus==='ERROR' ? false : derivedStatus==='CANCELED' ? false : derivedStatus==='COMPLETED' ? false : this.isEditable;
  }

}
